import React from 'react';
import { View, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { usePatientDevices } from '../hooks/usePatientDevices';
import { DeviceRow } from '../components';

const MyDevices = () => {
  const navigation = useNavigation();
  const { t } = useTranslation();
  const { devices, isLoading } = usePatientDevices();

  return (
    <MainLayout navigation={() => navigation.goBack()} scrollable isLoading={isLoading}>
      {devices.length === 0 ? (
        <Text className="text-sm text-gray-500 text-center mt-8">
          {t('screens.profile.myDevices.empty')}
        </Text>
      ) : (
        <View className="bg-white rounded-2xl border border-gray-200 px-4 overflow-hidden">
          <Text className="text-3xl font-bold text-gray-900 pt-5 pb-2">
            {t('screens.profile.myDevices.title')}
          </Text>
          {devices.map((device, index) => (
            <DeviceRow
              key={device.id}
              device={device}
              isLast={index === devices.length - 1}
            />
          ))}
        </View>
      )}
    </MainLayout>
  );
};

export default MyDevices;
